var React = require('react');

function LogoBlackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M347.68,52.55,307.39,203a41.67,41.67,0,0,1-40.29,31H221.5c-59.59,0-77-16.9-77-34.61,0-12,10-23.93,19-30.6a3.64,3.64,0,0,0-2.7-6.49c-51.41,6.75-74.42,71.7-117,71.7A43.74,43.74,0,0,1,0,190.39,44.67,44.67,0,0,1,1.52,179L40.79,32.39a43.69,43.69,0,0,1,85.89,11.22c0,3.38-1.48,9.08-5.12,25.33-4.08,18.18,11.4,29.9,23.75,29.9,16.7,0,34.56-20.47,63.63-24,2.62-.34,4.3,3.12,2.78,5.23-3.2,4.3-16.7,9.65-21.57,26.15A24.34,24.34,0,0,0,213.33,138c18.31,0,25.45-18.81,26.38-22.27L263.05,31A41.77,41.77,0,0,1,303.34,0h4A41.79,41.79,0,0,1,347.68,52.55Z"}));
}

LogoBlackInline.defaultProps = {"viewBox":"0 0 349.11 234"};

module.exports = LogoBlackInline;

LogoBlackInline.default = LogoBlackInline;
